import styled from '@emotion/styled';
import { FormControl } from '@mui/material';

// Container for the modal
export const Container = styled.div`
  padding: 1rem;
  width: 30rem;
  position: relative;
  text-align: center;
`;

// Confirmation message
export const Message = styled.p`
  margin-bottom: 2rem;
`;

export const InputContainer = styled(FormControl)`
  margin-bottom: 2rem;
`;
